import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container } from '@mui/material';
import config from '../config';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function PageNotAuth() {
    const title = config.title ? `Not Authenticated | ${config.title}` : 'Not Authenticated';
    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <Container>
                <StyledContent
                    sx={{ textAlign: 'center', alignItems: 'center' }}
                >
                    <Typography variant="h3" paragraph>
                        You are not authenticated!
                    </Typography>

                    <Typography sx={{ color: 'text.secondary' }}>
                        Sorry, you are not authenticated! Please login to access
                        the page
                    </Typography>

                    <Button
                        to="/"
                        size="large"
                        variant="contained"
                        component={RouterLink}
                    >
                        Go to Login
                    </Button>
                </StyledContent>
            </Container>
        </>
    );
}
